import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { loadStripe } from "@stripe/stripe-js/pure";
import { AuthenticationService, BaseApiService, EnvironmentConfig } from "../../core/core";

declare const environment: EnvironmentConfig;

@Injectable({
  providedIn: "root",
})
export class StripeService extends BaseApiService<any> {
  constructor(public httpClient: HttpClient, authenticationService: AuthenticationService) {
    super(httpClient, environment.adminApiDomain, "/api/admin/v1/account", true, authenticationService);
  }

  async init() {
    return await loadStripe(environment.stripeKey);
  }

  setupIntent() {
    const headers = this.getAuth();
    return this.httpClient.get(`${environment.adminApiDomain}/api/admin/v1/stripe/setup-intent`, { headers });
  }

  paymentMethods(accountId: string) {
    const headers = this.getAuth();
    return this.httpClient.get(`${environment.adminApiDomain}/api/admin/v1/stripe/payment-methods?accountId=${accountId}`, { headers });
  }

  createInvoice(accountId: string, description: string, items: { amount: number; description: string; currency?: string }[]) {
    const headers = this.getAuth();
    return this.httpClient.post(`https://localhost:65137/api/admin/v1/stripe/create-invoice`, { accountId, description, items }, { headers });
  }
}
